const CONFIRM_MAILING_CACHE = 'onboarding-confirm-mailing'

export function confirmMailingGet() {
  return sessionStorage.getItem(CONFIRM_MAILING_CACHE) === 'true'
}
export function confirmMailingSet(value: boolean) {
  sessionStorage.setItem(CONFIRM_MAILING_CACHE, value.toString())
}
